module.exports = "../dist/img/upper-banner-37.49b7.jpg";